export default [
    {
        path: 'relatorio-cuidado-mulher-prevencao-cancer',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-cuidado-mulher-prevencao-cancer' */
            '@/views/atencao-basica/relatorio-cuidado-mulher-prevencao-cancer/Index'
        ),
        redirect: 'relatorio-cuidado-mulher-prevencao-cancer/index',
        children: [
            {
                name: 'atencao-basica-relatorio-cuidado-mulher-prevencao-cancer-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-cuidado-mulher-prevencao-cancer' */
                    '@/views/atencao-basica/relatorio-cuidado-mulher-prevencao-cancer/List.vue'
                ),
            },
        ],
    },
]